import React from "react";
import ReviewManagementDetailed from "../../features/reviewmanagementdetailed"
import { OverwriteReviewProvider } from '../../features/revieweditmodal/hooks/OverwriteReviewContext';
import { ClientReviewManagementFilterSubHeader } from "../../layouts/ClientReviewManagementLayout";


const ReviewManagementDetailedPage = () => 
    <React.Fragment>
        <ClientReviewManagementFilterSubHeader includeCompletedSelect={false}/>
        <OverwriteReviewProvider>
             <section className="px-4 my-3 h-100">
                <ReviewManagementDetailed />
             </section>
        </OverwriteReviewProvider>
    </React.Fragment>

export default ReviewManagementDetailedPage;